export default __webpack_public_path__ + "static/media/HritikPawarResume.6ec1d25a.pdf";